import _ from 'lodash';

export const getHighlightedNameSegments = (name, query) => {
  const safeName = name ?? '';

  if (_.isEmpty(safeName)) {
    return [];
  }

  const normalizedQuery = (query ?? '').toLowerCase();

  if (_.isEmpty(normalizedQuery)) {
    return [{ key: '0', text: safeName, isMatch: false }];
  }

  const queryLength = normalizedQuery.length;
  const lowerName = safeName.toLowerCase();
  const segments = [];
  const words = safeName.split(/(\s+)/);

  words.reduce((offset, chunk) => {
    const chunkLower = lowerName.slice(offset, offset + chunk.length);
    const isWord = !/^\s+$/.test(chunk);
    const isMatch = isWord && chunkLower.startsWith(normalizedQuery);

    if (!isMatch) {
      segments.push({ key: String(offset), text: chunk, isMatch: false });

      return offset + chunk.length;
    }

    segments.push({ key: `${offset}-match`, text: chunk.slice(0, queryLength), isMatch: true });

    if (chunk.length > queryLength) {
      segments.push({
        key: `${offset}-rest`,
        text: chunk.slice(queryLength),
        isMatch: false,
      });
    }

    return offset + chunk.length;
  }, 0);

  return segments;
};
